module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAMCAYAAABm+U3GAAABPElEQVR4AWNwL/ChCWaoaOmYVtHccb2irduUEoMqWyeIVzR37gKadW7VqlXMDEDOWiDnPxB/A7LDyTG0pr1XH6j/IcSczscTJ05kZ6ifOZMLyfB/QB/U////n5FYQyvaOv2A+j5DDb1S3dytCBIHS4IMAhrYCjX8f2VLx4re3l5Ogt5v7igDqv8L0gNkb+3s7OSFyaGFU1cMUNEPqMJTVS19ktgMrF+1ig2oZj7cIc2d/UBvMiGrweK1Lkug4pew8Kpp7zFEtXyiKNB3h6GG/qpq6UzBmiqwuqijQw6o6SJU89fK1o4gcCR1dGgDDb0HFX8LDE8HnMkNl0T9lCk8wODYCItUIJ4JxJ9AfEjy7FXBm47xSYLCDWhIF9gwRMTu7Ojo4CcUsUQlqaqWrgSgoc+BuA+U+InRQ7MsDQCGkHTvAFAZwQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/arrow-down.png
// module id = 460
// module chunks = 0